var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Api } from '@app/Api';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { observable, action } from 'mobx';
import { Modal } from '@app/Components/Modal/Modal';
export var DocumentCell = /** @class */ (function (_super) {
    __extends(DocumentCell, _super);
    function DocumentCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isEditMode = false;
        _this._selectedOpionsValue = null;
        return _this;
    }
    DocumentCell.prototype.componentDidUpdate = function () {
        var _a;
        var item = (_a = this.props, _a.item), allDocuments = _a.allDocuments;
        var documentName = item.name;
        var doc = allDocuments.find(function (d) { return d.name === documentName; });
        var currentValue = this._selectedOpionsValue;
        if (!currentValue && doc)
            this._setSelectedOption({ value: '' + doc.id, label: doc.name });
    };
    DocumentCell.prototype._handleEditClick = function () {
        this._isEditMode = true;
    };
    DocumentCell.prototype._handleSaveClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentValue, documentDefinitionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isEditMode = false;
                        currentValue = this._selectedOpionsValue;
                        if (!currentValue)
                            return [2 /*return*/];
                        documentDefinitionId = +currentValue.value;
                        return [4 /*yield*/, Api.secured.updateDocumentDefinition(this.props.item.id, { documentDefinitionId: documentDefinitionId })];
                    case 1:
                        _a.sent();
                        this.props.onSave();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentCell.prototype._handleCancelClick = function () {
        this._isEditMode = false;
    };
    DocumentCell.prototype._toggle = function () {
        this._isEditMode = !this._isEditMode;
    };
    DocumentCell.prototype._setSelectedOption = function (selectedValue) {
        this._selectedOpionsValue = selectedValue;
    };
    DocumentCell.prototype.render = function () {
        var _a;
        var _this = this;
        var item = (_a = this.props, _a.item), allDocuments = _a.allDocuments;
        var itemName = item ? item.name : '';
        return (React.createElement("div", { onDoubleClick: this._handleEditClick, style: { display: 'list-item', whiteSpace: 'break-spaces' } },
            itemName,
            this._isEditMode && (React.createElement(Modal, { isOpen: this._isEditMode, headerTitle: "Set Document", toggle: this._toggle, footerbuttons: this._getFooterButtons() },
                React.createElement(Select, { options: allDocuments.map(function (doc) { return ({ value: '' + doc.id, label: doc.name }); }), value: this._selectedOpionsValue, onChange: function (selectedValue) { return _this._setSelectedOption(selectedValue); } })))));
    };
    DocumentCell.prototype._getFooterButtons = function () {
        return [
            {
                color: "success",
                onClick: this._handleSaveClick,
                title: 'Save'
            },
            {
                onClick: this._handleCancelClick,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], DocumentCell.prototype, "_isEditMode", void 0);
    __decorate([
        observable
    ], DocumentCell.prototype, "_selectedOpionsValue", void 0);
    __decorate([
        action.bound
    ], DocumentCell.prototype, "_handleEditClick", null);
    __decorate([
        action.bound
    ], DocumentCell.prototype, "_handleSaveClick", null);
    __decorate([
        action.bound
    ], DocumentCell.prototype, "_handleCancelClick", null);
    __decorate([
        action.bound
    ], DocumentCell.prototype, "_toggle", null);
    __decorate([
        action.bound
    ], DocumentCell.prototype, "_setSelectedOption", null);
    DocumentCell = __decorate([
        observer
    ], DocumentCell);
    return DocumentCell;
}(React.PureComponent));
